import { Navigate, Outlet } from "react-router-dom";

import { useAuth, type Role } from "./AuthContext";

/**
 * Route guard:
 *  - se manca il token o il ruolo → redirect a /login;
 *  - se la route richiede `admin` ma l'utente è `operation` → redirect a "/";
 *  - se richiede `operation` (default per il backoffice) accetta sia
 *    operation che admin.
 *
 * Il check è puramente client-side. Il backend deve comunque rifiutare le
 * chiamate non autorizzate (defense-in-depth).
 */
export function ProtectedRoute({ minRole }: { minRole?: Role }) {
  const auth = useAuth();

  if (!auth.token || !auth.role) {
    return <Navigate to="/login" replace />;
  }

  if (minRole === "admin" && auth.role !== "admin") {
    // operation tenta di aprire /settings → torna alla dashboard.
    return <Navigate to="/" replace />;
  }

  if (
    minRole === "operation" &&
    auth.role !== "operation" &&
    auth.role !== "admin"
  ) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
